/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import AuthenticatedNavigationLinkDefault, {
  AuthenticatedNavigationLinkDefaultProps,
} from "@/src/components/AuthenticatedNavigation/AuthenticatedNavigationLinkDefault";
import AuthenticatedNavigationLinkMessages, {
  AuthenticatedNavigationLinkMessagesProps,
} from "@/src/components/AuthenticatedNavigation/AuthenticatedNavigationLinkMessages";
import { useTheme } from "@mui/material/styles";
import AuthenticatedNavigationLinkCase, {
  AuthenticatedNavigationLinkCaseProps,
} from "@/src/components/AuthenticatedNavigation/AuthenticatedNavigationLinkCase";

export type AuthenticatedNavigationLinkProps = (
  | AuthenticatedNavigationLinkDefaultProps
  | ({
      type: "case";
    } & AuthenticatedNavigationLinkCaseProps)
  | ({
      type: "messages";
    } & AuthenticatedNavigationLinkMessagesProps)
) & { divider?: boolean };

export default function AuthenticatedNavigationLink(props: AuthenticatedNavigationLinkProps) {
  const theme = useTheme();

  const iconColor = theme.palette.common.black;

  switch (props.type) {
    case "customIcon":
    case "muiIcon":
      return <AuthenticatedNavigationLinkDefault {...props} iconColor={iconColor} />;
    case "messages":
      return <AuthenticatedNavigationLinkMessages {...props} iconColor={iconColor} />;
    case "case":
      return <AuthenticatedNavigationLinkCase {...props} />;
  }
}
